import Select from 'react-select'
import makeAnimated from 'react-select/animated'

const CategoryFilter = ({
  options,
  onChange,
  placeholder = 'Todas',
  id = 'selectFilterCategories',
  titleContent = (
    <label>
      Categorias{' '}
      <small>(Puedes filtrar, selecciona una o varias opciones)</small>
    </label>
  ),
  isMulti = true,
  value = false,
  showValue = false,
  customFilter = false,
  param = null,
}) => {
  const animatedComponents = makeAnimated()

  const handleFilterOptions = (option, inputValue) => {
    if (!inputValue || inputValue === '') return true
    const inputValueLower = inputValue.toLowerCase()
    const optionsGroupName = option.data.category_group_name
    const optionsGroupNameLower = optionsGroupName.toLowerCase()
    return (
      optionsGroupNameLower.includes(inputValueLower) ||
      option.label.toLowerCase().includes(inputValueLower)
    )
  }
  return (
    <div className="mb-3">
      {titleContent && titleContent}
      {showValue ? (
        <Select
          id={id}
          name={id}
          closeMenuOnSelect={true}
          components={animatedComponents}
          placeholder={placeholder}
          noOptionsMessage={() => 'Sin resultados'}
          isMulti={isMulti}
          options={options}
          onChange={(e) => onChange(e,param)}
          menuPosition="auto"
          value={value}
        />
      ) : (
        <Select
          id={id}
          name={id}
          closeMenuOnSelect={true}
          components={animatedComponents}
          placeholder={placeholder}
          noOptionsMessage={() => 'Sin resultados'}
          isMulti={isMulti}
          options={options}
          onChange={(e) => onChange(e,param)}
          menuPosition="auto"
          isSearchable
          {...(customFilter && {
            filterOption: (option, inputValue) =>
              handleFilterOptions(option, inputValue),
          })}
        />
      )}
    </div>
  )
}

export default CategoryFilter
